import { Outlet } from "react-router-dom";

export default function AppContent() {
  return (
    <section
      id="app-content-scroll"
      className="min-h-[calc(100vh-72px)] overflow-x-hidden overflow-y-auto p-4 md:p-6 lg:p-8"
    >
      <Outlet />
    </section>
  );
}
